import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import Loading from "../../Loading";
import QuestionCreator from "../QuestionCreator";

class EditQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionInfo: "",
      types: [],
      ability: "",
      module: "",
      discipline: "",
      difficulty: "",
      type: "",
      segment: "",
      loading: true
    };

    this.getQuestionInfo = this.getQuestionInfo.bind(this);
  }

  componentDidMount() {
    if (!this.props.questionId) return;
    Promise.all([this.getQuestionInfo(), this.getTypes()]).then(() => {
      this.setState({ loading: false });
    });
  }

  getQuestionInfo = async () => {
    try {
      const questionInfo = await axios.get(
        `${URL.api}evaluation/question/singleView/${this.props.questionId}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );
      this.setState({
        questionInfo: questionInfo.data.data,
        difficulty: questionInfo.data.data.difficulty_level_id,
        ability: questionInfo.data.data.ability_id,
        discipline: questionInfo.data.data.discipline_id,
        module: questionInfo.data.data.module_id,
        type: questionInfo.data.data.type_question_id,
        segment: questionInfo.data.data.segment_id
      });
    } catch (error) {
      toastr.error("Erro ao buscar informações da questão:", error);
    }
  };

  getTypes = async () => {
    try {
      const types = await axios.get(`${URL.api}evaluation/type_question/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      });
      this.setState({ types: types.data });
    } catch (error) {
      toastr.error("Erro ao buscar tipos de questão:", error);
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="d-flex justify-content-center align-items-center">
          <Loading />
        </div>
      );
    }
    return (
      <>
        <QuestionCreator
          onActivity={false}
          questionValue={0}
          questionValueChanger={() => null}
          questionId={this.props.questionId}
          questionInfo={this.state.questionInfo}
          index={0}
          listChanger={() => null}
          questionDuplicator={() => null}
          questionDeleter={() => null}
          history={null}
          types={this.state.types}
          abilities={[]}
          onSave={(q, e) => this.onSave(q, e)}
          ability={this.state.ability}
          segment={this.state.segment}
          module={this.state.module}
          filter={{
            difficulty: this.state.difficulty,
            discipline: this.state.discipline,
            type: this.state.type
          }}
          handleIsSaved={this.props.handleIsSaved}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EditQuestion);
